export default {
  data () {
    return {
      commentTypesList: [
        {
          type: 'public',
          value: 4,
          label: this.$t('pages.taskDetails.comments.modal.public'),
          icon: 'feather-users',
          metadata: {
            optionList: true
          }
        },
        {
          type: 'internal',
          value: 2,
          label: this.$t('pages.taskDetails.comments.modal.internal'),
          icon: 'feather-repeat',
          metadata: {
            optionList: true
          }
        },
        {
          type: 'private',
          value: 1,
          label: this.$t('pages.taskDetails.comments.modal.private'),
          icon: 'feather-lock',
          metadata: {
            optionList: true
          }
        },
        {
          type: 'api',
          value: 8,
          icon: 'feather-repeat',
          label: this.$t('pages.taskDetails.comments.modal.api'),
          metadata: {
            optionList: true
          }
        },
        {
          type: 'inspection_date',
          value: 16,
          label: this.$t('pages.taskDetails.comments.modal.inspectionDate'),
          icon: 'feather-users',
          metadata: {
            optionList: false
          }
        }
      ]
    }
  },
  methods: {
    getAllowedCommentTypes (actions, actionNamePrefix, client = null) {
      let commentsTypes = []
      this.commentTypesList.forEach(comment => {
        actions.forEach(action => {
          let commentType = {}
          let actionNameCommon = actionNamePrefix + '_' + comment.type
          let actionNameClient = actionNamePrefix + '_' + comment.type + '__' + client

          if (action === actionNameCommon || action === actionNameClient) {
            const camelType = comment.type.replace(/_([a-z])/g, (match, letter) => letter.toUpperCase())
            const suffix = action === actionNameClient ? client : '';
            const commentLabel = this.$t(`pages.taskDetails.comments.modal.${camelType}${suffix}`);
            commentType.action = action
            commentType.type = comment.type
            commentType.typeInt = comment.value
            commentType.metadata = comment.metadata
            commentType.client = action === actionNameClient ? client : null
            commentType.label = commentLabel
            commentsTypes.push(commentType)
          }
        })
      })
      return commentsTypes
    }
  }
}
